<template>
 <div class="container-fluid">
     <!-- static-pages -->
     <div class="row bg-white">
         <div class="static-pages">
             <div class="static-pages-title">
                 <!-- title -->
                 <div class="container">
                     <div class="col-xs-12 clearfix">
                        <h1 class="policy-title">BLD Shipping Policy</h1>
                     </div>
                 </div>
                 <!-- /.title -->
             </div>
             <!-- static-pages-content -->
             <div class="static-pages-content p-t p-b-xl">
                 <div class="container">
                     <div class="col-xs-12 clearfix">
                         <h3 class="text-a-right">January 2020</h3>
                     </div>
                     <div class="col-xs-12 clearfix">
                         <div class="w-full bg-light-blue">
                             <h2>Our 48 Hour Shipping Promise to You</h2>
                             <p>
                                 We will make every effort to build your custom gaming PC and ship it within two business days if your purchase
                                 is completed by 3:00 p.m. PST on a normal business day. All other standard orders will ship within three business days.
                             </p>
                         </div>
                         <p>
                            **Note that BLD does not ship to PO boxes nor do we offer will call options for our orders.
                         </p>
                         <h3>Standard ground shipping</h3>
                         <p>
                            We offer Express and Overnight shipping Service. We currently only offer international shipping to Canada.
                            To estimate when your order will arrive, use the chart below to calculate the build and transit time based on shipping method and destination selected.
                         </p>
                         <p class="text-bold m-y">
                             Shipping/Delivery Time and Pricing
                         </p>
                         <div class="table-responsive">
                             <table class="table table-bordered">
                                 <thead>
                                     <tr>
                                         <td>STANDARD GROUND SERVICE</td>
                                         <td>Standard Build Time*</td>
                                         <td>Blitz Build Time*</td>
                                         <td>Average Delivery Time in Transit</td>
                                     </tr>
                                 </thead>
                                 <tbody>
                                     <tr>
                                         <td>Contiguous U.S. Orders</td>
                                         <td>2 business days*<br>
                                             <div class="icon-build"/>
                                             <div class="icon-build"/>
                                         </td>
                                         <td>1 business day*<br>
                                             <div class="icon-build"/>
                                         </td>
                                         <td>3-6 business days<br>
                                             <div class="icon-shipping"/>
                                             <div class="icon-shipping"/>
                                             <div class="icon-shipping"/>
                                             <div class="icon-shipping-2"/>
                                             <div class="icon-shipping-2"/>
                                             <div class="icon-shipping-2"/>
                                         </td>
                                     </tr>
                                 </tbody>
                                 <thead>
                                     <tr>
                                         <td>EXPRESS SHIPPING</td>
                                         <td>Standard Build Time*</td>
                                         <td>Blitz Build Time*</td>
                                         <td>Average Delivery Time in Transit</td>
                                     </tr>
                                 </thead>
                                 <tbody>
                                     <tr>
                                         <td>Contiguous U.S. Orders</td>
                                         <td>2 business days*<br>
                                             <div class="icon-build"/>
                                             <div class="icon-build"/>
                                         </td>
                                         <td>1 business day*<br>
                                             <div class="icon-build"/>
                                         </td>
                                         <td>1-3 business days<br>
                                             <div class="icon-shipping"/>
                                             <div class="icon-shipping-2"/>
                                             <div class="icon-shipping-2"/>
                                         </td>
                                     </tr>
                                     <tr>
                                         <td>International Economy</td>
                                         <td>2 business days*<br>
                                             <div class="icon-build"/>
                                             <div class="icon-build"/>
                                         </td>
                                         <td>1 business day*<br>
                                             <div class="icon-build"/>
                                         </td>
                                         <td>2 business days<br>
                                            <div class="icon-shipping-2"/>
                                            <div class="icon-shipping-2"/>
                                         </td>
                                     </tr>
                                 </tbody>
                                 <thead>
                                     <tr>
                                         <td>OVERNIGHT SHIPPING</td>
                                         <td>Standard Build Time*</td>
                                         <td>Blitz Build Time*</td>
                                         <td>Average Delivery Time in Transit</td>
                                     </tr>
                                 </thead>
                                 <tbody>
                                     <tr>
                                         <td>Contiguous U.S. Orders</td>
                                         <td>2 business days*<br>
                                             <div class="icon-build"/>
                                             <div class="icon-build"/>
                                         </td>
                                         <td>1 business day*<br>
                                             <div class="icon-build"/>
                                         </td>
                                         <td>1 business day<br>
                                             <div class="icon-shipping-2"/>
                                         </td>
                                     </tr>
                                     <tr>
                                         <td>International Priority</td>
                                         <td>2 business days*<br>
                                             <div class="icon-build"/>
                                             <div class="icon-build"/>
                                         </td>
                                         <td>1 business day*<br>
                                             <div class="icon-build"/>
                                         </td>
                                         <td>1-2 business day<br>
                                            <div class="icon-shipping"/>
                                            <div class="icon-shipping-2"/>
                                         </td>
                                     </tr>
                                    </tbody>
                                    <thead>
                                    <tr>
                                        <td>STANDARD OFFSHORE SHIPPING</td>
                                        <td>Standard Build Time*</td>
                                        <td>Blitz Build Time*</td>
                                        <td>Average Delivery Time in Transit</td>
                                    </tr>
                                  </thead>
                                  <tbody>
                                     <tr>
                                         <td>Alaska and Hawaii Orders</td>
                                         <td>2 business days*<br>
                                             <div class="icon-build"/>
                                             <div class="icon-build"/>
                                         </td>
                                         <td>1 business day*<br>
                                             <div class="icon-build"/>
                                         </td>
                                         <td>2 business days<br>
                                             <div class="icon-shipping-2"/>
                                             <div class="icon-shipping-2"/>
                                         </td>
                                     </tr>
                                  </tbody>
                             </table>
                         </div>

                         <p>
                             *If your order is completed by 3:00 p.m. PST, on a normal business day, we promise to make every reasonable effort to build your custom gaming PC and ship it to you within two business days. All other standard orders usually ship within three business days. Overnight shipping does not include weekends or Saturday delivery.
                         </p>
                         <p class="text-bold">
                             Holiday Schedule
                         </p>
                         <p>
                             BLD observes the following U.S. holidays as non-business days.
                         </p>
                         <ul>
                            <li>New Years Day</li>
                            <li>President's day</li>
                            <li>Memorial Day</li>
                            <li>Independence Day</li>
                            <li>Labor Day</li>
                            <li>Thanksgiving Day</li>
                            <li>Black Friday</li>
                            <li>Christmas Eve</li>
                            <li>Christmas Day</li>
                            <li>New Years Eve</li>

                         </ul>
                         <p class="text-bold m-y">
                             Shipping/Delivery Pricing - PC Gaming Systems
                         </p>
                         <p>
                             The cost for expedited and express shipping is based on a flat fee. Use the table below as a quick reference for calculating shipping charge for an order. An additional shipping surcharge may apply to some items due to their size and weight. The surcharge
                             will be noted on the product description page. (For shipments to Alaska and Hawaii see surcharge fees below).
                         </p>
                         <div class="table-responsive">
                             <table class="table table-bordered small-table">
                                 <thead>
                                     <tr class="text-center">
                                         <td class="large"/>
                                         <td>Ground Shipping</td>
                                         <td>Express Shipping</td>
                                         <td>Overnight Shipping</td>
                                         <td>Standard Offshore Shipping</td>
                                         <td>International Economy</td>
                                         <td>International Priority</td>
                                     </tr>
                                 </thead>
                                 <tbody>
                                     <tr class="text-center">
                                         <td class="large">Contiguous U.S.</td>
                                         <td>$50.00</td>
                                         <td>$100.00</td>
                                         <td>$180.00</td>
                                         <td>N/A</td>
                                         <td>N/A</td>
                                         <td>N/A</td>
                                     </tr>
                                     <tr class="text-center">
                                         <td class="large">Alaska</td>
                                         <td>N/A</td>
                                         <td>N/A</td>
                                         <td>N/A</td>
                                         <td>$150.99</td>
                                         <td>N/A</td>
                                         <td>N/A</td>
                                     </tr>
                                     <tr class="text-center">
                                         <td class="large">Hawaii</td>
                                         <td>N/A</td>
                                         <td>N/A</td>
                                         <td>N/A</td>
                                         <td>224.99</td>
                                         <td>N/A</td>
                                         <td>N/A</td>
                                     </tr>
                                     <tr class="text-center">
                                         <td class="large">Canada</td>
                                         <td>N/A</td>
                                         <td>N/A</td>
                                         <td>N/A</td>
                                         <td>N/A</td>
                                         <td>$100.00</td>
                                         <td>$200.00</td>
                                     </tr>
                                 </tbody>
                             </table>
                         </div>
                         <p class="text-bold">
                             *Orders placed after 3pm Friday and Saturday and Sunday will be processed the next business day.
                         </p>
                         <p>
                             There will be a shipping fee applied to every monitor purchased with BLD. In addition, another $5 electronic recycling fee will be charged for every monitor purchased that is being shipped to California. See the chart below for more information.
                         </p>

                         <div class="table-responsive">
                            <table class="table table-bordered small-table shipping-monitors">
                                <thead>
                                    <tr class="text-center">
                                        <td>Shipping Method</td>
                                        <td>1 Monitor</td>
                                        <td>2 Monitors</td>
                                        <td>3 Monitors</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="text-center">
                                        <td>Ground Shipping</td>
                                        <td>$15 <br>($20 if shipping to CA)</td>
                                        <td>$30 <br>($40 if shipping to CA)</td>
                                        <td>$45 <br>($60 if shipping to CA)</td>
                                    </tr>
                                    <tr class="text-center">
                                        <td>Express Shipping</td>
                                        <td>$25 <br>($30 if shipping to CA)</td>
                                        <td>$50 <br>($60 if shipping to CA)</td>
                                        <td>$75 <br>($90 if shipping to CA)</td>
                                    </tr>
                                    <tr class="text-center">
                                        <td>Overnight Shipping</td>
                                        <td>$50 <br>($55 if shipping to CA)</td>
                                        <td>$100 <br>($110 if shipping to CA)</td>
                                        <td>$150 <br>($165 if shipping to CA)</td>
                                    </tr>
                                    <tr class="text-center">
                                        <td>International Economy</td>
                                        <td>$20</td>
                                        <td>$40</td>
                                        <td>$60</td>
                                    </tr>
                                    <tr class="text-center">
                                        <td>International Priority</td>
                                        <td>$30</td>
                                        <td>$60</td>
                                        <td>$90</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <p>Similarly, there will also be a shipping fee for the NZXT x Vertegear chair when purchased with BLD. The information is shown in the table below.</p>

                        <div class="table-responsive">
                            <table class="table-bordered">
                                <thead>
                                    <tr class="text-center">
                                        <td>Shipping Method</td>
                                        <td>Fees</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="text-center">
                                        <td>Ground Shipping</td>
                                        <td>$35</td>
                                    </tr>
                                    <tr class="text-center">
                                        <td>Express Shipping</td>
                                        <td>$100</td>
                                    </tr>
                                    <tr class="text-center">
                                        <td>Overnight Shipping</td>
                                        <td>$250</td>
                                    </tr>
                                    <tr class="text-center">
                                        <td>International Economy</td>
                                        <td>$200</td>
                                    </tr>
                                    <tr class="text-center">
                                        <td>International Priority</td>
                                        <td>$150</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                         <h3>Do we ship internationally?</h3>
                         <p>
                             We currently ship internationally but only to Canada.
                         </p>
                         <h3>How do we ship?</h3>
                         <p>
                             Parcel – Your shipment will arrive via FedEx. We do require a signature for every delivery. Help is always available at 800-228-9395 or <a class="mailto" href="mailto:bldsupport@nzxt.com">bldsupport@nzxt.com</a>.
                         </p>
                         <p>NZXT does not offer shipping to PO boxes unless it is for military.</p>

                         <h3>Additional information</h3>
                         <p>
                             BLD reserves the right to hold any order for a quality or security review. If your order is affected, you will be notified within two business days.
                         </p>
                         <p>
                             Standard ground shipping excludes parts, components, upgrades and other services unless otherwise specified. Shipping surcharges on over-sized items may apply – these charges will be indicated in the appropriate product information pages and will be displayed
                             in the shipping subtotal of your order if applicable.
                         </p>
                         <p>We charge a shipping tax for California and Washington. For Canada shipping fees, NZXT does not cover for importation fees nor it is liable for such fees.</p>
                         <p>
                             NZXT, Inc.
                             <br>15736 E. Valley Blvd

                             <br>City of Industry, CA 91744-3927
                         </p>
                     </div>
                 </div>
             </div>
             <!-- static-pages-content -->
         </div>
     </div>
     <!-- /.static-pages -->
 </div>
</template>

<script>
export default {
    name: "ShippingAndDeliveries"
}
</script>

<style scoped lang="scss">
    .static-pages-title {
        background-color: #d1d3d4;
        padding: 70px 0;

        .policy-title {
            font-family: 'Akkurat-Light', sans-serif;
            text-align: center;
            text-transform: uppercase;
            letter-spacing: 2px;
            font-size: 42px;
            color: #000;

            @media (max-width: 480px) {
                font-size: 26px;
            }

            @media (max-width: 767px) {
                font-size: 31px;
            }

            @media (max-width: 991px) {
                font-size: 36px;
            }
        }
    }

    .shipping-monitors {
        td:not(:first-child) {
            min-width: 228px;
        }
    }
</style>
